<template>
  <div class="adviser-enrolment-wrapper" :class="{ 'web-style': web }">
    <div class="adviser-enrolment-content">
      <div class="mb-12 boost-earnings-section">
        <h1>{{ heading }}</h1>
        <p>
          <strong>{{ intro }}</strong>
        </p>
        <ul>
          <li v-for="(bullet, index) in displayedBullets" :key="index">
            {{ bullet }}
          </li>
        </ul>
        <!-- The outro may hold an in-page link ("View Terms and conditions" to
             #terms); smooth-scroll it instead of letting the browser snap. -->
        <p v-if="outro" v-html="outro" @click="smoothScrollToAnchor"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import { smoothScrollToAnchor } from '@/helpers/dom/smooth-scroll-to-anchor';

  export default {
    name: 'AdviserEnrolmentAccentuatedContent',
    props: {
      heading: {
        type: String,
        default: 'Boost Your Earnings With Will Services',
      },
      intro: {
        type: String,
        default:
          'From 1 January 2026 to 31 December 2026, Old Mutual Will gives you:',
      },
      // When given, replaces the legacy five-bullet composition below.
      bullets: {
        type: Array,
        default: () => [],
      },
      // HTML allowed.
      outro: {
        type: String,
        default: '',
      },
      // OMW-419 pages: 816px column and 24px body line height. /mfc keeps
      // the legacy 768px / 22px layout by leaving this off.
      web: {
        type: Boolean,
        default: false,
      },
      // Legacy props still passed by MfcAdviserEnrolment.vue.
      earningsBullet: {
        type: String,
        default:
          "R500 (pre-tax) for a validated will from your clients, with a maximum annual earning of R60 000 from this incentive. The incentive is triggered for a client's first will on the Old Mutual Will platform.",
      },
      channelNote: {
        type: String,
        default:
          'Please note, the current incentive applies to PFA, DFA, and AFD adviser channels. Participation and incentive models for other distribution segments are underway. When confirmed, the details will be officially communicated to each channel.',
      },
    },
    methods: {
      smoothScrollToAnchor,
    },
    computed: {
      isMobile() {
        return this.$isMobileDevice();
      },
      displayedBullets() {
        if (this.bullets.length) return this.bullets;
        return [
          this.earningsBullet,
          'A new way to add value to client relationships.',
          'A simple tool to help identify estate planning opportunities.',
          'Support from our dedicated team throughout the process.',
          this.channelNote,
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  .adviser-enrolment-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .adviser-enrolment-content {
    width: 100%;
    max-width: 768px;
    justify-self: center;
    position: relative;
    z-index: 1;
  }

  section {
    margin-bottom: 60px;
  }

  .semi-bold {
    font-weight: 600 !important;
  }
  .article-link {
    color: #282828;
    font-weight: 500;
  }

  h1 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 24px;
    &.intro {
      font-size: 22px;
      font-weight: 400;
      line-height: 26px;
    }
  }
  h2 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 22px;
    line-height: 26px;
    margin: 40px 0 24px 0;
    &.sub-heading-one {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
    }
    &.sub-heading-two {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
    &.om-green {
      color: #50b848;
    }
  }

  .article-cta {
    color: #50b848;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    a {
      color: #50b848;
      font-family: 'Montserrat', sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
  }
  p,
  ul,
  li {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
  }
  blockquote {
    color: #50b848;
    border-left: 4px solid #50b848;
    padding-left: 24px;
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    margin: 40px 0;
    ul {
      li {
        list-style-type: disc;
        font-family: 'Montserrat', sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        text-align: left;

        &::marker {
          color: #50b848;
        }
      }
      p {
        color: #282828;
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
      }
      &.no-paragraphs {
        li {
          color: #282828;
        }
      }
    }
  }
  ul {
    margin: 24px 0;
    p {
      margin: 10px 0;
    }
  }

  .faq-category {
    margin-bottom: 40px;

    .faq-item {
      margin-bottom: 24px;
    }
  }
  // OMW-419 layout (spec 2.3): wider column, 16/24 body.
  .web-style {
    .adviser-enrolment-content {
      max-width: 816px;
    }
    p,
    ul,
    li {
      line-height: 24px;
    }
  }
</style>
